import Component from '@glimmer/component';
import { service } from '@ember/service';
import { on } from '@ember/modifier';
import { eq } from 'ember-truth-helpers';
import type Language from 'favoris-web/services/language';
import AdaptiveMenu from 'favoris-web/components/adaptive-menu';
import Icon from 'favoris-web/components/icon';

import GlobeIcon from '~icons/lucide/globe';

export default class LanguageSelectorComponent extends Component {
  @service declare language: Language;

  selectLanguage = (event: Event) => {
    const target = event.target as HTMLInputElement;
    this.language.setLanguage(target.value);
  };

  <template>
    <AdaptiveMenu
      @placement="dropdown-end"
      @title="Select Language"
      @contentClass="menu w-48 p-2"
    >
      <:trigger as |toggle|>
        <button
          type="button"
          tabindex="0"
          class="btn btn-ghost btn-sm gap-2"
          aria-label="Select content language"
          aria-haspopup="menu"
          {{on "click" toggle}}
        >
          <Icon @icon={{GlobeIcon}} class="h-4 w-4" />
          {{this.language.currentLanguageLabel}}
        </button>
      </:trigger>
      <:content>
        <ul role="menu" class="menu p-0">
          {{#each this.language.languageOptions as |option|}}
            <li>
              <label class="flex cursor-pointer items-center gap-3">
                <input
                  type="radio"
                  name="language-selector"
                  class="radio radio-sm"
                  value={{option.code}}
                  checked={{if
                    (eq this.language.preferredLanguage option.code)
                    "checked"
                  }}
                  {{on "change" this.selectLanguage}}
                />
                <span>{{option.label}}</span>
              </label>
            </li>
          {{/each}}
        </ul>
      </:content>
    </AdaptiveMenu>
  </template>
}
